<template>
    <b-navbar toggleable="md" class="top-nav" type="dark">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
        <div class="content-wrap">
          <b-collapse is-nav id="nav_collapse">
            <b-navbar-nav>
                <b-nav-item to="/home">Home</b-nav-item>
                <b-nav-item to="/makeaclaim">Make a claim</b-nav-item>
                <b-nav-item v-if="isStandalone" to="/myclaims/inprogress">Resume a claim</b-nav-item>
                <b-nav-item v-if="isTiga" to="/makeaclaim/resume">Resume a claim</b-nav-item>
                <b-nav-item to="/myclaims/list">Check status of a claim</b-nav-item>
                <b-nav-item to="/contact">Contact Us</b-nav-item>
            </b-navbar-nav>
            <b-navbar-nav class="ml-auto">
                <user-auth />
            </b-navbar-nav>
          </b-collapse>
        </div>        
    </b-navbar>
</template>

<script>

import userAuth from '@/components/UserAuth.vue'

export default {
  name: 'topNav',
  components: {
    userAuth
  },
  computed: {
    isStandalone() {
      return process.env.VUE_APP_FORM_TYPE == 'standalone';
    },
    isTiga() {
      return process.env.VUE_APP_FORM_TYPE == 'tiga';
    },
  }
}
</script>



